"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSchoolUpdateMessage = void 0;
exports.defaultSchoolUpdateMessage = {
    version: 1,
    eventType: 'schoolUpdate',
    headers: {
        correlationid: undefined
    },
    body: {
        schoolId: undefined,
        data: undefined
    }
};
//# sourceMappingURL=schoolUpdate.js.map